import type { Ref } from 'vue';
import { useRouter } from 'vue-router';

import { useBlacklistRuleRemove } from '../../../../composables/useBlacklistRuleRemove';
import type { BlacklistEditorState } from '../state/useBlacklistEditorState';

type UseBlacklistRuleDeleteOptions = Readonly<{
  state: BlacklistEditorState;
  isCancelled: () => boolean;
}>;

type UseBlacklistRuleDeleteReturn = Readonly<{
  remove: () => Promise<void>;
  removePending: Readonly<Ref<boolean>>;
}>;

export const useBlacklistRuleDelete = ({
  state,
  isCancelled,
}: UseBlacklistRuleDeleteOptions): UseBlacklistRuleDeleteReturn => {
  const router = useRouter();
  const { remove: removeRule, removePending } = useBlacklistRuleRemove();

  const remove = async (): Promise<void> => {
    const requestRoute = router.currentRoute.value;
    const ruleId = state.id.value;
    if (ruleId === null) {
      return;
    }
    const removed = await removeRule({ id: ruleId, name: state.form.state.formData.value.name });
    // Left mid-delete: the page is gone, so there is nothing to reset and nowhere to return from.
    if (removed && !isCancelled() && router.currentRoute.value === requestRoute) {
      // Unsaved edits of a deleted rule are moot; left dirty, the leave guard would prompt after the delete.
      state.restoreSeed();
      await router.push({ name: 'blacklist-auto-rules-poc' });
    }
  };

  return { remove, removePending };
};
